import React from 'react';
import { ResetPassword as NewResetPassword } from '@cokitchen/cokitchen-auth';
import { useParams, useNavigate } from 'react-router-dom';
import { LoginEnvType } from '@cokitchen/cokitchen-auth/dist/lib/login/types';

const authEnvironment = process.env.REACT_APP_AUTH_ENVIRONMENT as LoginEnvType;

const FormSection = () => {
  const { token }: any = useParams();
  const navigate = useNavigate();

  const login = () => {
    navigate('/login');
  };
  return (
    <div className='login-container w-full bg-red-9 p-4 md:overflow-auto'>
      <section className='auth-login__card px-8 md:px-16'>
        <NewResetPassword
          token={token}
          env={authEnvironment}
          onSuccess={login}
          successCta='Go to Login'
          description='Enter and confirm a new password'
        />
      </section>
    </div>
  );
};

export default FormSection;
